import React, { useEffect, useState } from "react";
import ReactMarkdown from 'react-markdown';
import documentationFile from './documentation.md';
import AppHeader from './v2/components/AppHeader';
import packageJson from '../package.json';
import './Documentation.css';

function Documentation() {
    const [markdownContent, setMarkdownContent] = useState("");
    const APP_VERSION = packageJson.version;

    useEffect(() => {
        fetch(documentationFile)
            .then((res) => res.text())
            .then((text) => setMarkdownContent(text))
            .catch((error) => console.error("Error fetching markdown file:", error));
    }, []);

    // No-ops for header callbacks we don't need here
    const noop = () => {};

    return (
        <div className="documentation-page">
            <AppHeader
                version={APP_VERSION}
                onClearAll={noop}
                onOpenFisPoints={noop}
                onOpenUssaPoints={noop}
            />
            <div className="documentation-content">
                <ReactMarkdown>{markdownContent}</ReactMarkdown>
            </div>
        </div>
    );
}

export default Documentation;
